module.exports = __webpack_public_path__ + "img/default-img.37d35eaf.png";